import React from 'react';
export const NotificationSettings = () => {
  return <div data-id="element-1452">
      <div className="mb-6" data-id="element-1453">
        <h2 className="text-lg font-semibold" data-id="element-1454">Notification Settings</h2>
        <p className="text-gray-600" data-id="element-1455">
          Manage how and when you receive notifications
        </p>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-1456">
        <h3 className="text-lg font-medium mb-4" data-id="element-1457">Email Notifications</h3>
        <div className="space-y-4" data-id="element-1458">
          <div className="flex items-center justify-between py-2" data-id="element-1459">
            <div data-id="element-1460">
              <p className="font-medium" data-id="element-1461">New Candidate Applications</p>
              <p className="text-sm text-gray-500" data-id="element-1462">
                Receive notifications when new candidates apply
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1463">
              <input type="checkbox" checked className="sr-only peer" data-id="element-1464" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600" data-id="element-1465"></div>
            </label>
          </div>
          <div className="flex items-center justify-between py-2" data-id="element-1466">
            <div data-id="element-1467">
              <p className="font-medium" data-id="element-1468">Screening Completions</p>
              <p className="text-sm text-gray-500" data-id="element-1469">
                Get notified when AI screenings are completed
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1470">
              <input type="checkbox" checked className="sr-only peer" data-id="element-1471" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600" data-id="element-1472"></div>
            </label>
          </div>
          <div className="flex items-center justify-between py-2" data-id="element-1473">
            <div data-id="element-1474">
              <p className="font-medium" data-id="element-1475">Interview Scheduling</p>
              <p className="text-sm text-gray-500" data-id="element-1476">
                Notifications for interview scheduling and changes
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1477">
              <input type="checkbox" checked className="sr-only peer" data-id="element-1478" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600" data-id="element-1479"></div>
            </label>
          </div>
          <div className="flex items-center justify-between py-2" data-id="element-1480">
            <div data-id="element-1481">
              <p className="font-medium" data-id="element-1482">Team Activity</p>
              <p className="text-sm text-gray-500" data-id="element-1483">
                Updates on actions taken by team members
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1484">
              <input type="checkbox" className="sr-only peer" data-id="element-1485" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600" data-id="element-1486"></div>
            </label>
          </div>
          <div className="flex items-center justify-between py-2" data-id="element-1487">
            <div data-id="element-1488">
              <p className="font-medium" data-id="element-1489">System Updates</p>
              <p className="text-sm text-gray-500" data-id="element-1490">
                Receive notifications about system updates and new features
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1491">
              <input type="checkbox" checked className="sr-only peer" data-id="element-1492" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600" data-id="element-1493"></div>
            </label>
          </div>
        </div>
      </div>
      <div className="mt-6 bg-white border border-gray-200 rounded-lg p-6" data-id="element-1494">
        <h3 className="text-lg font-medium mb-4" data-id="element-1495">In-App Notifications</h3>
        <div className="space-y-4" data-id="element-1496">
          <div className="flex items-center justify-between py-2" data-id="element-1497">
            <div data-id="element-1498">
              <p className="font-medium" data-id="element-1499">Real-time Alerts</p>
              <p className="text-sm text-gray-500" data-id="element-1500">
                Show real-time notifications in the dashboard
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1501">
              <input type="checkbox" checked className="sr-only peer" data-id="element-1502" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600" data-id="element-1503"></div>
            </label>
          </div>
          <div className="flex items-center justify-between py-2" data-id="element-1504">
            <div data-id="element-1505">
              <p className="font-medium" data-id="element-1506">Sound Alerts</p>
              <p className="text-sm text-gray-500" data-id="element-1507">
                Play sound when new notifications arrive
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1508">
              <input type="checkbox" className="sr-only peer" data-id="element-1509" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600" data-id="element-1510"></div>
            </label>
          </div>
          <div className="flex items-center justify-between py-2" data-id="element-1511">
            <div data-id="element-1512">
              <p className="font-medium" data-id="element-1513">Desktop Notifications</p>
              <p className="text-sm text-gray-500" data-id="element-1514">
                Show notifications on your desktop when browser is in background
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1515">
              <input type="checkbox" checked className="sr-only peer" data-id="element-1516" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600" data-id="element-1517"></div>
            </label>
          </div>
        </div>
      </div>
      <div className="mt-6 bg-white border border-gray-200 rounded-lg p-6" data-id="element-1518">
        <h3 className="text-lg font-medium mb-4" data-id="element-1519">Notification Delivery</h3>
        <div className="space-y-4" data-id="element-1520">
          <div data-id="element-1521">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1522">
              Email Digest Frequency
            </label>
            <select className="w-full border border-gray-300 rounded-md px-3 py-2" data-id="element-1523">
              <option data-id="element-1524">Real-time (as they happen)</option>
              <option data-id="element-1525">Daily digest</option>
              <option data-id="element-1526">Weekly digest</option>
              <option data-id="element-1527">Never</option>
            </select>
          </div>
          <div data-id="element-1528">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1529">
              SMS Notifications
            </label>
            <select className="w-full border border-gray-300 rounded-md px-3 py-2" data-id="element-1530">
              <option data-id="element-1531">Only for urgent matters</option>
              <option data-id="element-1532">All notifications</option>
              <option data-id="element-1533">Never</option>
            </select>
          </div>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-1534">
          <button className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors" data-id="element-1535">
            Save Preferences
          </button>
        </div>
      </div>
    </div>;
};